import styled from 'styled-components'

export const Container = styled.div`
  font-weight: var(--font-weight-semibold);
  display: flex;
  align-items: center;
`

export const TooltipContainer = styled.div`
  margin-left: var(--space-200);

  display: inline-block;
  vertical-align: text-bottom;
`
